import {
  CreateInternationalProductLiabilityClaimCommand,
} from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticationToken } from "../../auth/helpers";
import { setupClaimIntakeClient } from "../setup/setupClaimIntakeClient";
import { MetricsPublisher } from "../../metrics/metrics";
import { ProcessedApiResponse } from "../types";
import { createIPLClaimModelBuilder } from "src/app/IPL/IPLClaimModelBuilder";
import { FormStateType } from "src/forms/types";
import { IPLClaimModelAdditionalFields } from "src/app/IPL/types";

export async function createIPLClaimService(
  formState: FormStateType, additionalFields: IPLClaimModelAdditionalFields
) {
  const token = await getAuthenticationToken();
  if (!token) {
    return null;
  }

  const commandInput = createIPLClaimModelBuilder(
    formState,
    additionalFields
  );
  const client = setupClaimIntakeClient(token);
  const command = new CreateInternationalProductLiabilityClaimCommand(commandInput);
  const metricsPublisher = new MetricsPublisher("api.createIPLClaim");

  return await client
    .send(command)
    .then((response: any) => {
      const statusCode = response?.$metadata?.httpStatusCode?.toString();
      const processedResponse: ProcessedApiResponse = {
        statusCode,
        warningList: response.warningList,
        data: [
          {
            fieldName: "Claim Number",
            fieldValue: response.claimNumber,
          },
        ],
      };
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return processedResponse;
    })
    .catch((error: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
